import { Component, ElementRef, HostListener, inject, Injector, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AuthStateService } from '../../../core/auth/auth-state.service';
import { AuthService } from '../../../features/auth/services/auth.service';

@Component({
  selector: 'app-navbar',
  imports: [RouterLink],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  private readonly injector = inject(Injector);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);
  protected readonly authStateService = inject(AuthStateService);
  protected readonly isMobileMenuOpen = signal(false);
  protected readonly isDesktopMyNumericalOpen = signal(false);
  protected readonly isMobileMyNumericalOpen = signal(false);

  public toggleMobileMenu(): void {
    this.isMobileMenuOpen.update((isOpen) => !isOpen);
  }

  public closeMobileMenu(): void {
    this.isMobileMenuOpen.set(false);
    this.isMobileMyNumericalOpen.set(false);
  }

  public toggleDesktopMyNumerical(): void {
    this.isDesktopMyNumericalOpen.update((isOpen) => !isOpen);
  }

  public closeDesktopMyNumerical(): void {
    this.isDesktopMyNumericalOpen.set(false);
  }

  public toggleMobileMyNumerical(): void {
    this.isMobileMyNumericalOpen.update((isOpen) => !isOpen);
  }

  @HostListener('document:click', ['$event'])
  public handleDocumentClick(event: MouseEvent): void {
    if (!this.isDesktopMyNumericalOpen()) {
      return;
    }

    const target = event.target;
    if (!(target instanceof Node)) {
      return;
    }

    if (!this.elementRef.nativeElement.contains(target)) {
      this.isDesktopMyNumericalOpen.set(false);
    }
  }

  public async signOut(): Promise<void> {
    const authService = this.injector.get(AuthService);
    this.isDesktopMyNumericalOpen.set(false);
    await authService.signOut();
    this.closeMobileMenu();
  }
}
